"use strict";
module.exports = require('../../module.compiled').vendored['contexts'].ImageConfigContext;

//# sourceMappingURL=image-config-context.js.map